module.exports = __webpack_public_path__ + "static/media/message-icon.254f0082.svg";